import { FaRegFilePdf } from 'react-icons/fa'
import { HiOutlinePhotograph } from 'react-icons/hi'
import useQueryDowload from '../../customHooks/useQueryDowloand'
import useQueryDownloadCustom from '../../customHooks/useQueryDownloadCustom'
import { useAppSelector } from '../../store/hooks'
import STICKER_FWY from './stikerss-resourse/STICKER_FWY.png'
import STICKER_BAJA from './stikerss-resourse/STICKER_BAJA.png'
import STICKER_INO from './stikerss-resourse/STICKER_INO.png'
import STICKER_OAS from './stikerss-resourse/STICKER_OAS.png'
import STICKER_SOH from './stikerss-resourse/STICKER_SOH.png'
import STICKER_SSB from './stikerss-resourse/STICKER_SSB.png'
import STICKER_USA from './stikerss-resourse/STICKER_USA.png'
import STICKER_VFK from './stikerss-resourse/STICKER_VFK.png'
import STICKER_CUL from './stikerss-resourse/STICKER_CUL.png'
import STICKER_ACC from './stikerss-resourse/STICKER_ACC.png'

interface Brands {
  FWY : String,
  BAJA : String,
  USA: String,
  VERNFONK: String,
  INO: String,
  SSB: String,
  SOH: String,
  OASIS: String
  ACC: String
}
interface Props {
  id_campaign: string
  title: string
  endpoint: string
  titleButtonOne: string
  black_white: boolean
  brand_img: string
}

const Stikersgenerate = ({ id_campaign, title, endpoint, titleButtonOne, black_white, brand_img}:Props) => {

  
  const allbrandsimg :Brands = {
    FWY : STICKER_FWY,
    BAJA : STICKER_BAJA,
    USA: STICKER_USA,
    VERNFONK: STICKER_VFK,
    INO: STICKER_INO,
    SSB: STICKER_SSB,
    SOH: STICKER_SOH,
    OASIS: STICKER_OAS,
    ACC: STICKER_ACC
  }

  let imgPick: string = STICKER_FWY
  switch (brand_img) {
    case 'FWY':
      imgPick = STICKER_FWY
      break;
    case 'BAJA':
      imgPick = STICKER_BAJA
      break;
    case 'USA':
      imgPick = STICKER_USA
      break;
    case 'VERNFONK':
      imgPick = STICKER_VFK
      break;
    case 'INO':
      imgPick = STICKER_INO
      break;
    case 'SSB':
      imgPick = STICKER_SSB
      break;
    case 'SOH':
      imgPick = STICKER_SOH
      break;
    case 'OASIS':
      imgPick = STICKER_OAS
      break;
    case 'CUL':
      imgPick = STICKER_CUL
      break;
    case 'ACC':
      imgPick = STICKER_ACC
      break;
  }

  const { name } = useAppSelector(state => state.user)
  const { brand } = useAppSelector(state => state.campaign.detail)

  let nameimg = `stickers-${name}-${brand}`
  let nameimgbw = `stickers-black&white-${name}-${brand}`

  const { isLoading, onGenerate} = useQueryDownloadCustom({ name: `${nameimg.toUpperCase()}.pdf`})
  const { isLoading:isLoadingPng, onGenerate:onGeneratePng} = useQueryDownloadCustom({ name: `${nameimg.toUpperCase()}.pdf`})


  const downloadImg = () => {
    onGenerate({
      url: endpoint,
      params: {
        id_campaign
      },
      onComplete: (response, onDownload)=>{
        onDownload(response.data.pdf)
      }
    })
  }

 /*  const downloadQr = () => {
    onGeneratePng({
      url: '/api/purls/employee/campaigns/png/en/one',
      params: {
        id_campaign
      },
      onComplete: (response, onDownload)=>{
        onGeneratePng({
          url: endpoint,
          params: {
            id_campaign
          },
          onComplete: (response, onDownload)=>{
            onDownload(response.data.pdf)
          }
        })
      }
    })
  } */

 /*  const downloadPdf = () => {
    onGeneratePdf({
      url: endpoint,
      params: {
        id_campaign
      },
      onComplete: (response, onDownload)=>{
        onDownload(response.data.pdf)
      }
    })
  } */



  return (
    <div className="c-code-qr__container">
      <div className="c-code-qr__header">
        <span className="c-code-qr__title">{title}</span>
      </div>
      <div className="c-code-qr__content" >
        <img src={imgPick} className={`c-code-qr__img-qr ${black_white && 'c-code-qr__img-bw'}`} alt="qr-campaign" />
      </div>
      <button className={`c-code-qr__button-download ${isLoading && `c-code-qr__button-download--disabled`}`} onClick={downloadImg}>
        {
          isLoading ?
            <>
              Download...<div className="spiner"></div>
            </>
            :
            <>
              {titleButtonOne}<FaRegFilePdf />
            </>
        }
      </button>
      {/* <button className={`c-code-qr__button-download ${isLoadingPdf && `c-code-qr__button-download--disabled`}`} onClick={downloadPdf}>
        {
          isLoadingPdf ?
            <>
              Download...<div className="spiner"></div>
            </>
            :
            <>
              Download Stikers Black&White Cut outs
              <HiOutlinePhotograph />
            </>
        }
      </button> */}
    </div>
  )
}
export default Stikersgenerate